import { useEffect, useRef } from "react";
import { ITEM_HEIGHT } from "./time-utils";

export type TimeColumnClassNames = {
  column: string;
  item: string;
  itemSelected: string;
};

export default function TimeColumn({
  items,
  selectedValue,
  onSelect,
  label,
  classNames,
}: {
  items: string[];
  selectedValue: string;
  onSelect: (value: string) => void;
  label: string;
  classNames: TimeColumnClassNames;
}) {
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const index = items.indexOf(selectedValue);
    if (index >= 0 && listRef.current) {
      const targetScroll = index * ITEM_HEIGHT;
      listRef.current.scrollTo({ top: targetScroll, behavior: "instant" });
    }
  }, [selectedValue, items]);

  return (
    <div
      className={classNames.column}
      ref={listRef}
      role="listbox"
      aria-label={label}
    >
      {items.map((item) => (
        <button
          key={item}
          type="button"
          role="option"
          aria-selected={item === selectedValue}
          className={`${classNames.item} ${item === selectedValue ? classNames.itemSelected : ""}`}
          onClick={() => onSelect(item)}
        >
          {item}
        </button>
      ))}
    </div>
  );
}
